export default __webpack_public_path__ + "static/media/SEB.1cf56728.jpg";